var MuiDrawer = {
    /* put your new default props here */
    anchor: 'bottom',
};
export default MuiDrawer;
//# sourceMappingURL=MuiDrawer.js.map